<div #dialog class="airport-lookup-container search-dialog" tabindex="0">
  <div class="bg-dark action-bar d-block d-lg-none">
    <button (click)="close()" class="float-right close" type="button">
      Close
    </button>
  </div>
  <span class="sr-only" id="modalTitle">airport search</span>
  <div class="airport-lookup-tablist-container pl-0 pr-0 mt-2">
    <tabset role="tablist">
      <tab
        (select)="tabSelected('search')"
        aria-controls="airport-serach-panel"
        heading="{{
          airportLookupContent ? airportLookupContent.search : 'SEARCH'
        }}"
        id="airport-serach-tab"
      >
        <div
          aria-labelledby="airport-serach-tab"
          class="tab-Container row m-0"
          id="airport-serach-panel"
          role="tabpanel"
        >
          <div class="airport-serach-left-container pl-0 col-md-12 col-lg-12">
            <label class="search-label" for="search_input">
              {{ title }}
              <span class="sr-only">City or Airport</span>
            </label>
            <div [ngClass]="{ active: isSearchFocused }" class="input-group">
              <input
                #ctrl="ngModel"
                #searchField
                (focus)="onSearchFieldFocus(); searchField.placeholder = ''"
                (focusout)="
                  searchField.placeholder = airportLookupContent?.cityOrAirport;
                  onSearchFieldFocusout()
                "
                (input)="onSearchValueChange()"
                (keydown)="handleKeyDown($event)"
                [attr.aria-describedby]="
                  validationerrormessage.shouldShow
                    ? validationerrormessage.getId
                    : 'resultStatus'
                "
                [attr.placeholder]="airportLookupContent?.cityOrAirport"
                [name]="'search'"
                [ngClass]="{ searchFieldDataBorder: isSearchFieldData }"
                [ngModel]="selectedValue"
                aria-invalid="false"
                autocomplete="off"
                class="form-control mr-0 input-mobile-tab-class airport-search"
                id="search_input"
                ngModel
                pattern="^[a-zA-Z.\s]+$"
                type="text"
              />
              <span class="input-group-addon p-0">
                <button
                  (click)="clearSearchField()"
                  [ngClass]="{ 'd-none': searchField?.value?.length < 1 }"
                  class="btn btn-clear mr-2"
                  type="button"
                >
                  <span class="sr-only">Clear Search</span>
                </button>
                <span
                  [ngClass]="{
                    'd-lg-block d-md-block d-sm-block':
                      searchField?.value?.length < 1
                  }"
                  aria-hidden="true"
                  class="btn btn-search icon-search-icon d-none mr-2"
                ></span>
              </span>
            </div>
            <ngc-validation-error-message
              #validationerrormessage
              [control]="ctrl.control"
              [controlname]="'search'"
              [focusedFieldId]="'search_input'"
              [makeVisible]="true"
              [showErrorOnChange]="true"
            ></ngc-validation-error-message>
            <div
              [ngClass]="{ 'search-list-ios-safari': isIosSafariList }"
              class="search-result-container"
            >
              <div
                [ngClass]="{
                  'd-block': shouldShowResults()
                }"
                class="search-results d-none pl-1"
                tabindex="-1"
              >
                <ul #searchResultList>
                  <li
                    *ngFor="let result of searchResults; let i = index"
                    [attr.data-index]="i"
                    class="airport-list"
                  >
                    <a
                      (click)="selectedAirport(result)"
                      class="airportLookup-list"
                      href="javascript:void(0);"
                      tabindex="-1"
                    >
                      <span
                        class="airport-code col-sm-2 col-md-1 col-lg-2 col-xl-2 col-xxl-2 pl-0 pr-3"
                      >
                        {{ result.airportCode }}
                      </span>
                      <span
                        class="airport-city col-sm-10 col-md-11 col-lg-10 col-xl-10 col-xxl-10 pl-0"
                      >
                        {{ result.city
                        }}{{ result.region ? ', ' + result.region : '' }}
                      </span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <span
              [ngStyle]="{ 'height.px': 0 }"
              aria-live="assertive"
              class="sr-only"
              id="resultStatus"
              role="status"
            >
              <span
                #srResultStatus
                [ngStyle]="{ 'height.px': 0 }"
                aria-atomic="true"
                class="sr-only"
              ></span>
            </span>
            <span
              #srActiveAirport
              [ngStyle]="{ 'height.px': 0 }"
              aria-live="assertive"
              class="sr-only"
            ></span>
          </div>
        </div>
      </tab>

      <tab
        (select)="tabSelected('recent_search')"
        *ngIf="recentSearchesAvailableFlag && displayRecentSaveSearch"
        aria-controls="airport-recent-serach-panel"
        heading="{{
          airportLookupContent
            ? airportLookupContent.recentSearch
            : 'RECENT SEARCH'
        }}"
        id="airport-recent-serach-tab"
      >
        <div
          #recentSearchContainer
          aria-labelledby="airport-recent-serach-tab"
          class="tab-Container row m-0"
          id="airport-recent-serach-panel"
          role="tabpanel"
        >
          <recent-searches
            (selectedResult)="onRecentSelected($event)"
            [recentSearchResult]="recentSearchSelected"
            class="col-lg-12 p-0"
          ></recent-searches>
        </div>
      </tab>

      <tab
        (select)="tabSelected('saved_search')"
        *ngIf="savedSearchesAvailableFlag && displayRecentSaveSearch"
        aria-controls="airport-saved-serach-panel"
        heading="{{
          airportLookupContent
            ? airportLookupContent.savedSearch
            : 'SAVED SEARCH'
        }}"
        id="airport-saved-serach-tab"
      >
        <div
          #savedSearchContainer
          aria-labelledby="airport-saved-serach-tab"
          class="tab-Container row m-0"
          id="airport-saved-serach-panel"
          role="tabpanel"
        >
          <saved-searches
            (savedSearchesAvailable)="savedSearchesAvailable($event)"
            (savedTrip)="getSavedTrip($event)"
            [searchResults]="savedTrips"
            class="col-lg-12 p-0"
          ></saved-searches>
        </div>
      </tab>
    </tabset>
    <a
      (click)="openFullAirportList()"
      *ngIf="isDelta"
      [ngClass]="{ 'airport-list-absolute': isAirportListScrollable }"
      [ngStyle]="
        airportLookupContent?.fullAirportList === ('' || undefined || null) && {
          visibility: 'hidden'
        }
      "
      aria-haspopup="true"
      class="full-airport-list d-inline-block"
      draggable="false"
      href="javascript:void(0);"
    >
      {{ airportLookupContent?.fullAirportList }}
    </a>
    <a
      (click)="openFullAirportList()"
      *ngIf="!isDelta"
      [ngClass]="{ 'airport-list-absolute': isAirportListScrollable }"
      aria-haspopup="true"
      class="full-airport-list d-inline-block"
      draggable="false"
      href="javascript:void(0);"
    >
      {{ airportLookupContent?.fullAirportList }}
    </a>
  </div>
  <button
    (click)="close()"
    class="search-flyout-close float-right d-none d-lg-block circle-outline icon-moreoptionsclose"
    type="button"
  >
    <img
      alt="close"
      src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
    />
  </button>

  <!--tabcode-->

  <!--tabcode-->
</div>
